import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/tourisme";
export default function SecteurTourisme() { return <SectorLayout data={data} />; }
